// extracted by mini-css-extract-plugin
module.exports = {"usps":"styles-module--usps--3M7Ij","usp-item":"styles-module--usp-item--2J7Ei","usp-item__icon":"styles-module--usp-item__icon--3DIqN"};